namespace $ {

	export class $shm_hitalama_file extends $giper_baza_entity.with({

		Size: $giper_baza_atom_real,

		File: $giper_baza_atom_link.to( ()=> $giper_baza_file ),

		// Storage: $giper_baza_atom_text,
		Tg_file_id: $giper_baza_atom_text,

	}){

		private write_tail: Promise<void> = Promise.resolve()
		private write_sequence = 0

		@ $mol_mem
		write_source( next?: File | null ): File | null { return next ?? null }

		get write_source_file() { return this.write_source() ?? undefined }
		set write_source_file( next: File | undefined ) { this.write_source(next ?? null) }

		file_link() {
			return this.File()?.val() ?? null
		}

		file( next?: null | $giper_baza_file ) {
			return this.File(next)?.remote( next ) ?? null
		}

		file_ensure() {
			this.land().sync()
			let slot = this.File()
			if( !slot ) {
				this.File( null )
				slot = this.File()
			}
			return slot?.ensure( this.land() ) ?? null
		}

		@ $mol_action
		tg_get_blob() {
			const botToken = $shm_hitalama_profile.current()!.secret_val('backup_bot_token')
			const fileId = this.Tg_file_id()?.val()

			const data: any = $mol_fetch.json( `https://api.telegram.org/bot${botToken.trim()}/getFile?file_id=${fileId}` )
			if( !data.ok ) {
				throw new Error(data.toString() || 'Не удалось получить информацию о файле')
			}

			const filePath = data.result.file_path
			const downloadUrl = `https://api.telegram.org/file/bot${botToken.trim()}/${filePath}`

			const blob = $mol_fetch.blob( downloadUrl )
			return blob
		}

		@ $shm_hitalama_process_wire_action
		tg_send_file( file: File ) {
			const file_id = this.Tg_file_id()?.val()
			if( file_id ) return file_id

			const profile = $shm_hitalama_profile.current()
			if( !profile ) return ''

			const botToken = profile.secret_val('backup_bot_token')
			const chatId = profile.secret_val('backup_chat_id')
			if( !botToken || !chatId ) return ''

			const formData = new ($mol_wire_sync(FormData))
			formData.append('chat_id', chatId.trim())
			formData.append('document', file, file.name)

			const data: any = $mol_fetch.json( `https://api.telegram.org/bot${botToken.trim()}/sendDocument`, {
				method: 'POST',
				body: formData
			})
			if (!data.ok) throw new Error(data.toString())
			
			const next_file_id = data.result.document.file_id
			this.Tg_file_id(null)?.val( next_file_id )
			return next_file_id
		}

		@ $shm_hitalama_process_wire_action
		tg_send_written_file() {
			const file = this.write_source_file
			if( !file ) return ''

			const file_id = this.Tg_file_id()?.val()
			if( file_id ) return file_id

			const profile = $shm_hitalama_profile.current()
			if( !profile ) return ''

			const botToken = profile.secret_val('backup_bot_token')
			const chatId = profile.secret_val('backup_chat_id')
			if( !botToken || !chatId ) return ''

			const formData = new ($mol_wire_sync(FormData))
			formData.append('chat_id', chatId.trim())
			formData.append('document', file, file.name)

			const data: any = $mol_fetch.json( `https://api.telegram.org/bot${botToken.trim()}/sendDocument`, {
				method: 'POST',
				body: formData
			})
			if (!data.ok) throw new Error(data.toString())
			
			const next_file_id = data.result.document.file_id
			this.Tg_file_id(null)?.val( next_file_id )
			return next_file_id
		}

		@ $shm_hitalama_process_wire_action
		baza_upload_file( file: Blob ) {
			return this.baza_upload_snapshot(file).link
		}

		@ $mol_action
		baza_upload_snapshot( file: Blob ) {
			const baza_file = this.file_ensure()
			if( !baza_file ) throw new Error( 'Failed to create baza file' )

			baza_file.blob( file )
			// Capture the revision in the same synchronous turn as the CRDT write.
			// A later remote change must not label these local bytes as its version.
			return {link:baza_file.link().toString(),version:$shm_hitalama_file_cache_version(baza_file)}
		}

		@ $shm_hitalama_process_wire_action
		baza_upload_written_file() {
			const file = this.write_source_file
			if( !file ) return ''

			const baza_file = this.file_ensure()
			if( !baza_file ) throw new Error( 'Failed to create baza file' )

			baza_file.blob( file )
			return baza_file.link().toString()
		}

		@ $mol_mem
		baza_upload_progress() {
			const link = this.file_link()
			if( !link ) return null
			return ( this.$.$giper_baza_glob.yard() as any ).send_progress_land?.( link.land() ) ?? null
		}

		baza_upload_progress_peek() {
			const link = this.file_link()
			if( !link ) return null
			return ( this.$.$giper_baza_glob.yard() as any ).send_progress_land?.( link.land(), false ) ?? null
		}

		@ $mol_action
		write( file: File ) {
			// Stabilize scheduling across a parent's suspension without awaiting upload.
			$mol_wire_sync(this).write_schedule(file)
		}

		@ $mol_action
		write_schedule( file: File ) {
			const sequence=++this.write_sequence
			this.write_source_file = file
			this.title( file.name )
			this.Size(null)?.val( file.size )

			// Capture the immutable payload; never reread a mutable latest-file slot
			// after suspension. A slow earlier upload cannot overwrite a later one.
			const done = this.write_tail.catch(()=>{}).then(async()=>{
				const snapshot=await $mol_wire_async(this).baza_upload_snapshot(file)
				try {
					await this.$.$shm_hitalama_file.writeFileToOPFS(file,this.opfs_name(),snapshot.version)
				} finally {
					if(sequence === this.write_sequence) this.write_source_file = undefined
				}
			})
			this.write_tail = done
			done.catch(error=>this.write_report_error(error))

			$mol_wire_async( this ).tg_send_file(file).catch((error:unknown)=>this.write_report_error(error))
			return {done}
		}

		/** Completion of writes scheduled so far; errors remain observable. */
		write_pending() { return this.write_tail }

		write_report_error( error: unknown ) {
			if( !$mol_promise_like(error) ) console.error(error)
		}

		content_version() {
			const file=this.file()
			return file ? $shm_hitalama_file_cache_version(file) : undefined
		}

		size() {
			return this.Size()?.val() ?? 0
		}

		opfs_name() {
			return this.link().toString()
		}

		opfs_exists_peek() {
			try {
				return $mol_wire_sync($shm_hitalama_file).fileExistsInOPFS( this.opfs_name() )
			} catch (error) {
				if( $mol_promise_like( error ) ) return false
				throw error
			}
		}

		@ $mol_mem
		baza_download_loaded() {
			const file = this.file()
			if( !file ) return 0

			try {
				return file.chunks().reduce( ( sum, chunk )=> sum + chunk.byteLength, 0 )
			} catch (error) {
				if( $mol_promise_like( error ) ) return 0
				throw error
			}
		}

		@ $mol_mem
		baza_download_progress() {
			if( this.opfs_exists_peek() ) return null
			this.$.$mol_state_time.now( 250 )

			const file = this.file()
			if( !file ) return null

			const loaded = this.baza_download_loaded()
			const total = this.size()
			const ratio = total ? Math.min( loaded / total, 1 ) : 0

			return {
				loaded,
				total,
				ratio,
				active: ratio < 1,
			}
		}

		@ $mol_mem
		blob() {
			if( this.write_source_file ) return this.write_source_file

			const file = this.file()
			// Metadata can arrive before the chunks revision. Keep size in this
			// channel's dependencies even on a cache hit (OPFS reads are actions).
			const total = this.Size()?.val()
			// Read in this reactive channel, not inside the isolated OPFS action.
			const version = this.content_version()
			const from_opfs = this.read_from_opfs(version)
			if( from_opfs && ( total == null || from_opfs.size === total ) ) return from_opfs

			if( file ) {
				const blob = file.blob()
				// A resolved one-shot timeout does not re-check its condition on replay.
				// Suspend until the subscribed chunks/size actually change instead.
				if( total != null && blob.size !== total ) $mol_fail_hidden( new $mol_promise_blocker() )

				this.write_to_opfs( blob, version )
				return blob
			}
			// if( this.Storage()?.val() != 'telegram' ) return this.file()?.blob()
			if( !this.Tg_file_id()?.val() ) return null

			const blob = this.tg_get_blob()
			this.write_to_opfs( blob )
			return blob
		}

		@ $mol_mem
		text() {
			const blob = this.blob()
			if( !blob ) return ''

			const text = $mol_wire_sync(blob).text()
			return text
		}

		@ $mol_mem
		buffer() { //note it can be detached! by decodeAudioData for example
			const blob = this.blob()
			if( !blob ) return
			const buf = $mol_wire_sync(blob).arrayBuffer()
			return buf
		}

		blob_uri_async(): Promise< string | undefined > {
			const blob = this.blob()
			// Keep wire suspension synchronous. An async body turns a thrown
			// pending dependency into a rejected Promise carrying that Promise.
			return blob ? $mol_blob_uri( blob ) : Promise.resolve( undefined )
		}

		async blob_async() {
			const blob = await this.blob()
			return blob
		}

		@ $mol_action
		write_to_opfs( file: Blob, version?: string ) {
			$mol_wire_async( $shm_hitalama_file ).writeFileToOPFS( file, this.opfs_name(), version ).catch( error => {
				if( !$mol_promise_like( error ) ) console.error( error )
			} )
		}

		@ $mol_action
		read_from_opfs( version?: string ) {
			try {
				const file = $mol_wire_sync(this.$.$shm_hitalama_file).readFileFromOPFS( this.opfs_name(), version )
				if( !file ) return null
				const total = this.size()
				if( total > 0 && file.size !== total ) {
					// A cache miss must not asynchronously delete a newer writer's bytes.
					return null
				}
				// OPFS stores bytes under an extensionless CRDT link, not MIME
				// metadata. Restore the authoritative type when reading the cache.
				const type = this.file()?.type()
				return type && type !== file.type ? file.slice( 0, file.size, type ) : file
			} catch (error) {
				if( !$mol_promise_like( error ) ) return null
				throw error
			}
		}

		static async writeFileToOPFS( file: Blob, name: string, version?: string ) {
			return $shm_hitalama_file_cache.write(file,name,version)
		}

		static async readFileFromOPFS( fileName: string, version?: string ) {
			return $shm_hitalama_file_cache.read(fileName,version)
		}

		static async deleteFileFromOPFS( fileName: string ) {
			return $shm_hitalama_file_cache.remove(fileName)
		}

		static async fileExistsInOPFS( fileName: string ) {
			try {
				const root = await navigator.storage.getDirectory()
				await root.getFileHandle( fileName )
				return true
			} catch( error: any ) {
				if( error.name === 'NotFoundError' ) {
					return false
				}
				throw error
			}
		}
		
	}

}
